<div class="gradient">
    <img class="cover-img" src="{{src}}" width="100%" height="auto" alt="">
</div>